import {Injectable} from '@angular/core';
import {Device} from '@capacitor/device';
import {AppConfigModelService} from '../Models/Core/app-config-model.service';
import {AppConfigDto} from '../../Models/Core/app-config.model';
import {AVAILABLE_LANGUAGES_CONST} from '../../Shared/Const/languages.const';

@Injectable({
  providedIn: 'root'
})
export class AppConfigManagerService {

  appConfig!: AppConfigDto;
  defaultAppConfig!: AppConfigDto;

  constructor(
    protected appConfigModel: AppConfigModelService
  ) {
  }


  /**
   * Obtener configuración de la app
   *
   */
  public async getAppConfig() {
    this.appConfig = await this.appConfigModel.list();
    this.defaultAppConfig = new AppConfigDto();

    if (!this.appConfig) {
      await this.setDefaultAppConfig();
      return;
    }

    await this.checkAppConfig();
  }


  /**
   * Guardar nueva configuración
   *
   */
  public async saveAppConfig() {
    await this.appConfigModel.save(this.appConfig);
  }


  /**
   * Comprueba si hay alguna propiedad que no esta asignada
   *
   */
  private async checkAppConfig() {
    const updatedAppConfig: AppConfigDto = new AppConfigDto({...this.defaultAppConfig, ...this.appConfig});

    if (JSON.stringify(this.appConfig) === JSON.stringify(updatedAppConfig)) {
      return;
    }

    this.appConfig = updatedAppConfig;
    await this.saveAppConfig();
  }


  /**
   * Asignar valores por defecto
   *
   */
  private async setDefaultAppConfig() {
    const deviceLangCode: string = (await Device.getLanguageCode()).value;
    const isLanguageAvailable: boolean = AVAILABLE_LANGUAGES_CONST.some((lang) => lang.code === deviceLangCode);
    this.defaultAppConfig.language = isLanguageAvailable ? deviceLangCode : 'es';

    this.appConfig = this.defaultAppConfig;
    await this.saveAppConfig();
  }

}
